import { createContext, useContext, useMemo } from 'react';
import type { PortOverlaySide } from '@/GraphEditor/drawingLayer/portOverlay/portOverlayTypes';

interface PortOverlayNodeContextValue {
    openOverlay: (portName: string, portSide: PortOverlaySide) => void;
    closeOverlay: () => void;
    isActive: (portName: string, portSide: PortOverlaySide) => boolean;
}

const PortOverlayNodeContext = createContext<PortOverlayNodeContextValue>({
    openOverlay: () => {},
    closeOverlay: () => {},
    isActive: () => false,
});

export const usePortOverlayNode = () => useContext(PortOverlayNodeContext);

interface Props {
    openOverlay: (portName: string, portSide: PortOverlaySide) => void;
    closeOverlay: () => void;
    isActive: (portName: string, portSide: PortOverlaySide) => boolean;
    children: React.ReactNode;
}

export const PortOverlayNodeContextProvider: React.FC<Props> = ({ openOverlay, closeOverlay, isActive, children }) => {
    const value = useMemo(() => ({ openOverlay, closeOverlay, isActive }), [openOverlay, closeOverlay, isActive]);
    return <PortOverlayNodeContext.Provider value={value}>{children}</PortOverlayNodeContext.Provider>;
};
